import { render, staticRenderFns } from "./PlacesToVisit.vue?vue&type=template&id=561d903a"
import script from "./PlacesToVisit.vue?vue&type=script&lang=ts"
export * from "./PlacesToVisit.vue?vue&type=script&lang=ts"
import style0 from "./PlacesToVisit.vue?vue&type=style&index=0&id=561d903a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./placeToVisit.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2770918514%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fplace-to-visit%2FPlacesToVisit.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./placeToVisit.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2770918514%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fplace-to-visit%2FPlacesToVisit.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports